import { RESULTS_PAGE_SIZE } from '@awaze/mfe-common.api.site-search-service';
import { calculateSelectedFilters, calculateTotalPages, } from './search-context.utils';
export const PAGINATION_CLICK = 'PAGINATION_CLICK';
export const FILTER_ACCOMMODATION_TYPE_TOGGLE = 'FILTER_ACCOMMODATION_TYPE_TOGGLE';
export const FILTER_FEATURE_TOGGLE = 'FILTER_FEATURE_TOGGLE';
export const FILTER_SITE_FEATURE_TOGGLE = 'FILTER_SITE_FEATURE_TOGGLE';
export const FILTER_REMOVE_ALL = 'FILTER_REMOVE_ALL';
export const FILTER_BATHROOM_TOGGLE = 'FILTER_BATHROOM_TOGGLE';
export const FILTER_BEDROOM_TOGGLE = 'FILTER_BEDROOM_TOGGLE';
export const FILTER_GRADE_TOGGLE = 'FILTER_GRADE_TOGGLE';
export const FILTER_RATING_TOGGLE = 'FILTER_RATING_TOGGLE';
export const FILTER_UPDATE_NIGHTS = 'FILTER_UPDATE_NIGHTS';
export const FILTER_UPDATE_RANGE = 'FILTER_UPDATE_RANGE';
export const FILTER_UPDATE_MIN_MAX_PRICE = 'FILTER_UPDATE_MIN_MAX_PRICE';
export const FILTER_REMOVE_MIN_OR_MAX_PRICE = 'FILTER_REMOVE_MIN_OR_MAX_PRICE';
export const ONLY_DISCOUNTED_TOGGLE = 'ONLY_DISCOUNTED_TOGGLE';
export const SORT_ORDER_UPDATED = 'SORT_ORDER_UPDATED';
export const REMOVE_POPULAR_DESTINATION = 'REMOVE_POPULAR_DESTINATION';
export const RESULTS_UPDATED = 'RESULTS_UPDATED';
export const RESULTS_UPDATING = 'RESULTS_UPDATING';
export const NO_RESULTS = 'NO_RESULTS';
export const REPLACE_SEARCH_CRITERIA = 'REPLACE_SEARCH_CRITERIA';
export const UPDATE_SEARCH_CRITERIA = 'UPDATE_SEARCH_CRITERIA';
const toggleArrayItem = (arrayItems, itemToToggle) => {
    const removeFromArray = arrayItems.filter((arrayItem) => arrayItem !== itemToToggle);
    return arrayItems.includes(itemToToggle)
        ? removeFromArray
        : arrayItems.concat(itemToToggle);
};
export function SearchContextReducer(state, action) {
    switch (action.type) {
        case REPLACE_SEARCH_CRITERIA: {
            return {
                ...state,
                searchCriteria: {
                    ...action.searchCriteria,
                },
            };
        }
        case UPDATE_SEARCH_CRITERIA: {
            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    ...action.searchCriteria,
                },
            };
        }
        case PAGINATION_CLICK: {
            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    page: action.page,
                },
            };
        }
        case REMOVE_POPULAR_DESTINATION: {
            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    page: 1,
                    regionName: null,
                    features: toggleArrayItem(state.searchCriteria.features, action.featureId),
                },
            };
        }
        case FILTER_FEATURE_TOGGLE: {
            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    page: 1,
                    features: toggleArrayItem(state.searchCriteria.features, action.featureId),
                },
            };
        }
        case FILTER_ACCOMMODATION_TYPE_TOGGLE: {
            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    page: 1,
                    accommodationTypes: toggleArrayItem(state.searchCriteria.accommodationTypes, action.accommodationTypeId),
                },
            };
        }
        case FILTER_SITE_FEATURE_TOGGLE: {
            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    page: 1,
                    siteFeatures: toggleArrayItem(state.searchCriteria.siteFeatures, action.siteFeatureId),
                },
            };
        }
        case FILTER_BATHROOM_TOGGLE: {
            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    page: 1,
                    bathrooms: state.searchCriteria.bathrooms === action.id ? null : action.id,
                },
            };
        }
        case FILTER_BEDROOM_TOGGLE: {
            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    page: 1,
                    bedrooms: state.searchCriteria.bedrooms === action.id ? null : action.id,
                },
            };
        }
        case FILTER_GRADE_TOGGLE: {
            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    page: 1,
                    grade: state.searchCriteria.grade === action.id ? null : action.id,
                },
            };
        }
        case FILTER_RATING_TOGGLE: {
            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    page: 1,
                    rating: state.searchCriteria.rating === action.id ? null : action.id,
                },
            };
        }
        case FILTER_REMOVE_ALL: {
            const { discounts, ...remainingSearchCriteria } = state.searchCriteria;
            return {
                ...state,
                searchCriteria: {
                    ...remainingSearchCriteria,
                    accommodationTypes: [],
                    page: 1,
                    features: [],
                    siteFeatures: [],
                    bathrooms: null,
                    bedrooms: null,
                    grade: null,
                    rating: null,
                    minPrice: null,
                    maxPrice: null,
                },
            };
        }
        case SORT_ORDER_UPDATED: {
            return {
                ...state,
                searchCriteria: { ...state.searchCriteria, sort: action.sort, page: 1 },
            };
        }
        case FILTER_UPDATE_NIGHTS: {
            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    nights: action.nights,
                },
            };
        }
        case FILTER_UPDATE_RANGE: {
            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    range: action.range,
                },
            };
        }
        case FILTER_UPDATE_MIN_MAX_PRICE: {
            const minPrice = action.minPrice !== null && action.minPrice > 0 ? action.minPrice : null;
            const maxPrice = action.maxPrice !== null && action.maxPrice > 0 ? action.maxPrice : null;
            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    minPrice,
                    maxPrice,
                },
            };
        }
        case FILTER_REMOVE_MIN_OR_MAX_PRICE: {
            return {
                ...state,
                searchCriteria: {
                    ...state.searchCriteria,
                    [action.field]: null,
                },
            };
        }
        case ONLY_DISCOUNTED_TOGGLE: {
            const removeDiscounts = state.searchCriteria.discounts === 1;
            const { discounts, ...remainingSearchCriteria } = state.searchCriteria;
            const modifiedSearchCriteria = removeDiscounts
                ? remainingSearchCriteria
                : {
                    ...remainingSearchCriteria,
                    discounts: 1,
                };
            return {
                ...state,
                searchCriteria: modifiedSearchCriteria,
            };
        }
        case RESULTS_UPDATED: {
            const { aggregations, coordinates, properties, rhsLevel, total } = action.results;
            const { accommodationTypes, features, siteFeatures, bathrooms, bedrooms, grade, rating, minPrice, maxPrice, size, } = state.searchCriteria;
            const hasResults = properties?.length > 0 || coordinates?.length > 0;
            const chosenPageSize = size ?? RESULTS_PAGE_SIZE;
            return {
                ...state,
                coordinates,
                properties,
                hasResults,
                total,
                aggregations,
                rhsLevel,
                totalPages: calculateTotalPages(total, chosenPageSize),
                totalSelectedFilters: calculateSelectedFilters({
                    accommodationTypes,
                    features,
                    siteFeatures,
                    bathrooms,
                    bedrooms,
                    grade,
                    rating,
                    minPrice,
                    maxPrice,
                }),
                loading: false,
            };
        }
        case NO_RESULTS: {
            return {
                ...state,
                properties: [],
                hasResults: false,
                totalPages: 0,
                loading: false,
            };
        }
        case RESULTS_UPDATING: {
            return { ...state, loading: true };
        }
        default:
            return state;
    }
}
//# sourceMappingURL=search-context-reducer.js.map